export default __webpack_public_path__ + "static/media/profile.38f88332.svg";